import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function SearchBar({onChange, value}) {
  return (
        <div className='mb-4 flex items-center bg-theme rounded-lg'>
          <FontAwesomeIcon className='mx-3 text-gray-100' icon={faSearch} />
          <input 
        type={'text'}
        placeholder={'search'}
        value={value}
        onChange={onChange}
        className="shadow appearance-none border rounded-r-lg w-full p-2 py-[9px] text-gray-700 
              leading-tight focus:outline-none focus:shadow-outline"/>
        </div>
  )
}
